export class RestoreTemplateResourceTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<RestoreTemplateResourceType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreTemplateResourceTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
